import { defineComponent } from "vue";
import { playTurboHostList } from "@/config/host";
import { NODE_ENV } from "@com/config/env";
export default defineComponent({
    setup: function setup() {
        var PTUrl = playTurboHostList[NODE_ENV];
        var handleToPt = function() {
            window.location.href = PTUrl;
        };
        return {
            handleToPt: handleToPt
        };
    }
});
